export enum cmsColorOptionType {
  HEXCODE = 'hex-code',
  THEME = 'theme',
}
